import React, { useEffect, useRef, useState } from "react";
import { Button, Layout } from "components";
import styles from "./ChatPage2.module.scss";
import {
  Avatar,
  Divider,
  ListItem,
  ListItemAvatar,
  TextareaAutosize,
} from "@material-ui/core";
import {
  Autocomplete,
  ListItemText,
  Stack,
  TextField,
  Typography,
  List,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import ChatContent from "pages/ChatPage/components/ChatContent";
import DuoSharpIcon from "@mui/icons-material/DuoSharp";
import { createChat, getChatData, getChats } from "service/ChatService";
import {
  setChatById,
  setChats,
  setMessageChat,
} from "store/slices/ChatSlice";
import { useDispatch, useSelector } from "react-redux";
import userInfo from "utils/userInfo";
import send from "assets/icons/send.svg";
import ErrorOutlineTwoToneIcon from "@mui/icons-material/ErrorOutlineTwoTone";
import VideocamTwoToneIcon from "@mui/icons-material/VideocamTwoTone";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import EmployeeSelectUserId from "hooks/EmployeeSelect/EmployeeSelectUserId";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ScaleLoader } from "react-spinners";
import WebSocketComponent from "http/websockets";
import moment from "moment";
import classNames from "classnames";
import { log } from "pdfmake/pdfmake/build/pdfmake";
import { postChatsOrder } from "service/OrderService";
import { postRaportsChats } from "service/StatementsService";

const ChatPage2 = ({ chats ,setRender, id,typeDoc}) => {
  const [search, setSearch] = useState("");

  const user = userInfo();
  const [data] = useState();
 

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState();
  const [image, setImage] = useState();
  const [userId, setUserId] = useState();
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState([]);
  const [selectedChatTitle, setSelectedChatTitle] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [rightBlock, setRightBlock] = useState(true);
  const [text, setText] = useState("");
  const [isLeftSideOpen, setIsLeftSideOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const messagesContainerRef = useRef(null);

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });


  const [anchorEl, setAnchorEl] = React.useState(null);


 





  const getFormattedTime = (date) => {
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Asia/Bishkek",
    };

    const isoFormattedDate = date.replace(/\./g, "-");
    const formattedTime = new Date(isoFormattedDate).toLocaleTimeString(
      "ky-KG",
      options
    );

    return formattedTime;
  };




 


 


 

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (text === "") {
      setNotify({
        isOpen: true,
        message: " Попытка отправки пустого сообщения",
        type: "warning", sound: 'warning'
      });
    } else {
      try {
        if (typeDoc == 'Приказ') {
          
          let response = await postChatsOrder(id,{
            message : text
          })
        }else {
          let response = await postRaportsChats(id, {
            message : text
          })
        }
        
        setRender(true)
        setText("");
        // if (messagesContainerRef.current) {
        //   messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
        // }
      } catch (error) {

      }
    }
  };

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  }, [messagesContainerRef, chats]);
  return (
    <div>
      <div
      ref={messagesContainerRef}
      className="messagesContainer"
      style={{
        width: "100%",
        backgroundColor: "white",
        height: "100%",
        borderRadius: "10px 10px 0px 10px",
        display: "flex",
        overflowY: 'auto',
        marginBottom: '40px'
      }}
    >

        {rightBlock ? (
          <div
            
          >
           
            <div className={styles.right_body}>
              <React.Fragment>
                {chats === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >

                    <ScaleLoader color="black" size={30} />
                  </div>
                ) : (
                  <div id="messages" className={styles.messages}>
                    <ul
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >

                       
                      {chats?.length !== 0 && chats?.map((item) => (
                        <React.Fragment key={item.id}>
                         
                          <li
                            className={
                              // user.userId === message.user
                                // ? styles.sent
                                 styles.replies
                            }
                          >
                            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>

                            <img style={{width: '35px', height: '35px', borderRadius: '50%'}} src={item?.photo} alt="" />
                            <p style={{minWidth: 'fit-content', }}>{item?.employee_name}</p>
                            </div>
                            <p>
                              {item?.message}
                              <br />{" "}
                              <span className={styles.message_date}>
                                {item?.date_time}
                              </span>
                            </p>
                          </li>
                        </React.Fragment>
                      ))

                        
                      }
                    </ul>
                  </div>
                )}
              </React.Fragment>

              <form className={styles.formsong}>
                <input
                  name="message"
                  className={styles.input}
                  placeholder="Введите сообщение"
                  autoComplete="off"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                ></input>

                <button
                  type="submit"
                  style={{
                    border: "none",
                    background: "none",
                    padding: 0,
                    cursor: "pointer",
                  }}
                  onClick={handleSubmit}
                >
                  <img src={send} className={styles.send} alt="" />
                </button>
              </form>
            </div>
          </div>
        ) : (
          <div
          
          ></div>
        )}
        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalTitle={"Выберите собеседника"}
        >
          <div>
            <EmployeeSelectUserId
              selectedEmployee={setSelectedEmployee}
              setSelectedEmployeeLabel={setSelectedEmployeeLabel}
              isMulti={false}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => setOpenModal(false)}
              className="btn_modal_close"
            >
              Закрыть
            </Button>
          
          </div>
        </ModalWindow>
      </div>
    
    </div>
  );
};

export default ChatPage2;
